import React from 'react'

class About extends React.Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    render() {
        return(
            <>
       {/* Section: About */}
       <section id="about">
       <div className="container">
         <h2 className="heading">
           Gabe <span className="text-primary">Sequeira</span>
         </h2>
         <div className="about-content">
           <div className="about-text">
             <h3>
               A Little Bit More {" "}
               <span className="text-primary">About Me</span>
             </h3>
             <p>
             I'm Gabe Sequeira, a software developer based in Montpelier, VT.<br />
            I was a student in the fourth cohort of Burlington Code Academy's Software Development Bootcamp in 2020. I became a developer, musician and actor in the years since.
            In 2024, I completed an A.S. in Computer Science at Southern New Hampshire University.
             This year, I'm breaking back into tech--this time, for good.<br />
               Check out my work on <a href='https://github.com/gabesequeira?tab=repositories'>GitHub</a> or on this site under Projects.<br />
             </p>
             <p></p>
           </div>
           <div className="about-image">
           <img src={require('./img/about.jpg')} alt='My face' title="Gabe" />
           </div>
         </div>
       </div>
     </section>
     </>
        )
    }
}

export default About;